module.exports = __webpack_public_path__ + "img/reddit_icon_white.b1cfcd44.svg";